import * as React from 'react';

import { Watch } from 'scrollmonitor-react';

import './articleQuoteFull.scss';

class ArticleQuoteFull extends React.Component {
  render() {
    let theBlock = this.props.block;
    let renderCite = false;
    let inView = this.props.isInViewport;
    let elementHasBeenInView = this.props.isAboveViewport;
 
    // Change classname based on boolean
    let viewClassName = (inView)? 'is-inview-true' : 'is-inview-false';
    let beenViewed = (elementHasBeenInView)? ' is-viewed' : ' is-not-viewed';

    if(theBlock.blockQuoteAuthor !== "" | theBlock.blockQuoteAuthorTitle !== "") {
        renderCite = true
    }

    if(theBlock.blockQuote === "") {
        return ""
    } else {
        return (
            <div className={theBlock.blockHideOnMobile ? viewClassName + beenViewed + " d-none d-md-block " + theBlock.blockType : viewClassName + beenViewed + " " + theBlock.blockType}> 
                <div className="container">
                    <div className="rpw">
                        <div className="col-12 mb-sm-4">
                            <div className="row">
                                <div className="col-md-8 offset-md-2 text-center">
                                    <hr className="quoteTop"/>
                                    <blockquote cite={theBlock.blockQuoteCite}>
                                        <p>{theBlock.blockQuote}</p>
                                    </blockquote>
                                    {renderCite &&
                                    <cite>
                                        {theBlock.blockQuoteAuthor !== "" ? <span className="author">{theBlock.blockQuoteAuthor}</span> : ""}
                                        {theBlock.blockQuoteAuthorTitle !== "" ? <span className="authorTitle">{theBlock.blockQuoteAuthorTitle}</span> : ""}
                                        {theBlock.blockQuoteAuthorTitleLineTwo !== "" ? <span className="authorTitle line-two">{theBlock.blockQuoteAuthorTitleLineTwo}</span> : ""}
                                    </cite>
                                    }
                                    <hr className="quoteBottom"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
  }
}

//const InviewOptions = {offsetY: 0.2, showGuides: false, fullElementInView: false, debounceTime: 30}

export default Watch(ArticleQuoteFull);
